import BaseService from "@/services/Base-service.js";

class TicketService {
  get controllerName() { return '/Ticket/'; }

  createTicket(model) {
    return BaseService.post(this.controllerName + 'CreateTicket', model);
  }

  getBookmarkedTickets(filterVM) {
    return BaseService.get(this.controllerName + 'ListBookmarkedTickets', filterVM);
  }

  getAllTicketsOfOrganization(filterVM) {
    return BaseService.get(this.controllerName + 'GetAllTicketsOfOrganization', filterVM );
  }

  getUsersTickets(filterVM) {
    return BaseService.get(this.controllerName + 'GetUsersTickets', filterVM );
  }

  GetTicketsReferredToUser(filterVM) {
    return BaseService.get(this.controllerName + 'GetTicketsReferredToUser', filterVM );
  }

  getTicketById(ticketId) {
    return BaseService.get(this.controllerName + 'GetTicketById/' + ticketId);
  }

  getTicketWithDetails(ticketId) {
    return BaseService.get(this.controllerName + 'GetTicketWithDetails/' + ticketId);
  }

  getTicketWithDetailsAndReferrals(ticketId) {
    return BaseService.get(this.controllerName + 'GetTicketWithDetailsAndReferrals/' + ticketId);
  }

  getStatusesByCompany(companyId) {
    return BaseService.get(this.controllerName + 'GetStatusesByCompany/' + companyId);
  }

  deleteTicket(deleteVM) {
    return BaseService.post(this.controllerName + 'DeleteTicket' , deleteVM);
  }

  referTicket(vM) {
    return BaseService.post(this.controllerName + 'ReferTicket', vM);
  }

  changeTicketStatus(vM) {
    return BaseService.post(this.controllerName + 'ChangeTicketStatus', vM);
  }

  modifyTicketDetailByCreator(vm) {
    return BaseService.post(this.controllerName + 'ModifyTicketDetailByCreator', vm);
  }

  deleteTicketDetailByCreator(vm) {
    return BaseService.post(this.controllerName + 'DeleteTicketDetailByCreator', vm);
  }

  ticketBookmarkToggle(ticketId) {
    return BaseService.post(this.controllerName + 'TicketBookmarkToggle/' + ticketId);
  }
}
export default new TicketService();